export const Role = {
  USER: 'User',
  ADMIN: 'Admin',
};

export const AccessBlockedMessage =
  'This feature is disabled by the Admin due to an ongoing maintenance activity. Please check notifications section for more details.';

export const ParallelMessage = {
  OVER_LIMIT:
    'Congrats your offer has been applied. Now you&apos;ve got additional COUNT Parallels firepower for blazing fast speed.',
  UNDER_LIMIT: 'No. of Initiated and Running Tasks',
};

export const ExcludeOnPremURLS = [
  'https://dashboard.hyperexecute.cloud',
  'https://stage-dashboard.hyperexecute.cloud',
  'https://beta-dashboard.hyperexecute.cloud',
];

export const NormalUrls = [
  'https://stage-eu-hyperexecute.lambdatestinternal.com',
  'https://eu-hyperexecute.lambdatest.com',
  'https://hyperexecute.lambdatest.com',
  'https://stage-hyperexecute.lambdatestinternal.com',
  'https://dev.lambdatestinternal.com',
];
if (window?._env_?.REACT_APP_EXCLUDE_URL) {
  ExcludeOnPremURLS.push(window._env_.REACT_APP_EXCLUDE_URL);
}

export const JOB_DETAIL_TOOLTIP = 'lt-new-jd-tooltip';
export const PROJECT_DETAIL_TOOLTIP = 'project-detail-page-tooltip';
